import {
  Box,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { cloneDeep } from "lodash";
import { useState, useEffect, useRef } from "react";

const find_text_inter_span = "/"; // 找出文字个数的中间连接符

const SearchDoc = (props) => {
  const { setShowSearch } = props;
  const [drag, setDrag] = useState({
    mousex: 0,
    mousey: 0,
    tempx: "",
    tempy: "",
    isdrag: false,
    drag_obj: null,
    drag_obj_x: 0,
    drag_obj_y: 0,
  });
  const [highlights, setHighlights] = useState([]);
  const [findText, setFindText] = useState("");
  const [findPointer, setFindPointer] = useState(-1);
  const [foundHighlightRule, setFoundHighlightRule] = useState(0);
  const [foundSelectedRule, setfoundSelectedRule] = useState(0);

  useEffect(() => {
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("touchstart", handleMouseDown);
    document.addEventListener("touchmove", handleMouseMove);
    document.addEventListener("touchend", handleMouseUp);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchstart", handleMouseDown);
      document.removeEventListener("touchmove", handleMouseMove);
      document.removeEventListener("touchend", handleMouseUp);
    };
    // eslint-disable-next-line
  }, []);

  const handleMouseDown = (event) => {
    setDrag({
      ...drag,
      tempx: "",
      tempy: "",
    });
    if (!event) event = window.event; // 10/5/2014 - ver 5.0d - for older IE <= 9
    let fobj = event.target || event.srcElement; // The element being clicked on (FF || IE)

    // get current screen scrollTop and ScrollLeft
    let scrollLeft =
      document.body.scrollLeft || document.documentElement.scrollLeft;
    let scrollTop =
      document.body.scrollTop || document.documentElement.scrollTop;

    // ver 5.1 - 10/17/2014 - Let users highlight textareas and inputs by not dragging them
    if (typeof fobj.nodeName !== "undefined")
      if (
        fobj.nodeName.toLowerCase() === "input" ||
        fobj.nodeName.toLowerCase() === "textarea"
      )
        return true;

    // If parent or grandparents of obj is a dragme item then make the parent the fobj
    for (fobj; fobj; fobj = fobj.parentNode) {
      // 7/30/2014 ver 5.0b
      if (fobj.className) if (String(fobj.className).match(/dragme/i)) break;
    }

    if (fobj)
      if (fobj.className.match(/dragme/i)) {
        const tmepDrag = cloneDeep(drag);
        tmepDrag.isdrag = true; // Tell mouseMove we are dragging
        tmepDrag.drag_obj = fobj; // Put dragged element into global variable
        tmepDrag.drag_obj_x = parseInt(drag.drag_obj.offsetLeft); // get current x of element
        tmepDrag.drag_obj_y = parseInt(drag.drag_obj.offsetTop); // get current y of element

        // Add scrollTop and scrollLeft to recorded mouse position
        tmepDrag.mousex = event.clientX + scrollLeft;
        tmepDrag.mousey = event.clientY + scrollTop;

        /* if touchevents from iphone */
        if (event.type === "touchstart")
          if (event.touches.length === 1) {
            // Only deal with one finger
            var touch = event.touches[0]; // Get the information for finger #1
            // node.style.position = "absolute";
            tmepDrag.mousex = touch.pageX; // includes scroll offset
            tmepDrag.mousey = touch.pageY; // includes scroll offset
          }
        setDrag({ ...tmepDrag });
        return true; // 8/25/2014 version 5.0c (Now all buttons and onclick work on iphone and android)
      }
  };

  const handleMouseMove = (event) => {
    if (drag.isdrag) {
      const tmepDrag = cloneDeep(drag);
      // Use 'event' above because IE only uses event and FF can use anything
      if (!event) event = window.event; // 10/5/2014 - ver 5.0d - for older IE <= 9
      tmepDrag.tempx = event.clientX; // record new mouse position x
      tmepDrag.tempy = event.clientY; // record new mouse position y

      // get current screen scrollTop and ScrollLeft
      var scrollLeft =
        document.body.scrollLeft || document.documentElement.scrollLeft;
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;

      // Add scrollTop and scrollLeft to drag.tempx and drag.tempy
      tmepDrag.tempx += scrollLeft;
      tmepDrag.tempy += scrollTop;

      tmepDrag.drag_obj.style.position = "absolute";

      /* if touchevents from iphone */
      if (event.type === "touchmove")
        if (event.touches.length === 1) {
          // Only deal with one finger
          var touch = event.touches[0]; // Get the information for finger #1
          tmepDrag.tempx = touch.pageX; // includes scroll offset
          tmepDrag.tempy = touch.pageY; // includes scroll offset
        }

      tmepDrag.drag_obj.style.left =
        tmepDrag.drag_obj_x + drag.tempx - drag.mousex + "px"; // 7/30/2014 ver 5.0b
      tmepDrag.drag_obj.style.top =
        drag.drag_obj_y + drag.tempy - drag.mousey + "px"; // 7/30/2014 ver 5.0b
      setDrag({ ...tmepDrag });
      return false;
    }
  };
  const handleMouseUp = (e) => {
    if (drag.isdrag === true) {
      if (drag.tempx === "" && drag.tempy === "") {
        //if (document.getElementById('find_msg'))
        // document.getElementById('find_msg').innerHTML += " You clicked!";
      }
    }
    setDrag({
      ...drag,
      isdrag: false,
    });
  };

  const highlight = (word, node, arr) => {
    if (!node) node = document.body;
    for (node = node.firstChild; node; node = node.nextSibling) {
      //console.log(node.nodeName);
      if (node.nodeType === 3) {
        // text node
        let n = node;
        //console.log(n.nodeValue);
        let match_pos = 0;
        //for (match_pos; match_pos > -1; n=after)
        // {
        //match_pos = n.nodeValue.search(re); // Ver 5.3b - Now NOT using regular expression because couldn't search for $ or ^
        match_pos = n.nodeValue.toLowerCase().indexOf(word.toLowerCase()); // Ver 5.3b - Using toLowerCase().indexOf instead

        if (match_pos > -1) {
          // if we found a match
          let before = n.nodeValue.substr(0, match_pos); // split into a part before the match
          let middle = n.nodeValue.substr(match_pos, word.length); // the matched word to preserve case
          //var after = n.splitText(match_pos+word.length);
          let after = document.createTextNode(
            n.nodeValue.substr(match_pos + word.length)
          ); // and the part after the match
          let highlight_span = document.createElement("span"); // create a span in the middle
          if (foundHighlightRule === 1) {
            highlight_span.className = "highlight";
          } else {
            highlight_span.style.backgroundColor = "yellow";
            highlight_span.style.color = "black";
          }

          highlight_span.appendChild(document.createTextNode(middle)); // insert word as textNode in new span
          n.nodeValue = before; // Turn node data into before
          n.parentNode.insertBefore(after, n.nextSibling); // insert after
          n.parentNode.insertBefore(highlight_span, n.nextSibling); // insert new span
          arr.push(highlight_span); // add new span to highlights array
          setHighlights(arr);
          highlight_span.id = "highlight_span" + arr.length;
          node = node.nextSibling; // Advance to next node or we get stuck in a loop because we created a span (child)
        }
        // }
      } // if not text node then it must be another element
      else {
        // nodeType 1 = element   原 matcher = /textarea|input/i   让input不支持搜索,现在把input从正则中去除,这个是定制化需求,看个人需要来改
        if (
          node.nodeType === 1 &&
          node.nodeName.match(/textarea/i) &&
          node.type.match(/textarea|text|number|search|email|url|tel/i) &&
          !getStyle(node, "display").match(/none/i)
        )
          textarea2pre(node);
        else {
          if (
            node.nodeType === 1 &&
            !getStyle(node, "visibility").match(/hidden/i)
          )
            if (
              node.nodeType === 1 &&
              !getStyle(node, "display").match(/none/i)
            )
              // Dont search in hidden elements
              // Dont search in display:none elements
              highlight(word, node, arr);
        }
      }
    }
  };

  const unhighlight = () => {
    for (let i = 0; i < highlights.length; i++) {
      let the_text_node = highlights[i].firstChild; // firstChild is the textnode in the highlighted span

      let parent_node = highlights[i].parentNode; // the parent element of the highlighted span

      // First replace each span with its text node nodeValue
      if (highlights[i].parentNode) {
        highlights[i].parentNode.replaceChild(the_text_node, highlights[i]);
        if (i === findPointer) selectElementContents(the_text_node); // ver 5.1 - 10/17/2014 - select current find
        parent_node.normalize(); // The normalize() method removes empty Text nodes, and joins adjacent Text nodes in an element
        normalize(parent_node); // Ver 5.2 - 3/10/2015 - normalize() is incorrect in IE. It will combine text nodes but may leave empty text nodes. So added normalize(node) function below
      }
    }
    // Now reset highlights array
    setHighlights([]);
    setFindPointer(-1);
  }; // end function unhighlight()

  const normalize = (node) => {
    //http://stackoverflow.com/questions/22337498/why-does-ie11-handle-node-normalize-incorrectly-for-the-minus-symbol
    if (!node) {
      return;
    }
    if (node.nodeType === 3) {
      while (node.nextSibling && node.nextSibling.nodeType === 3) {
        node.nodeValue += node.nextSibling.nodeValue;
        node.parentNode.removeChild(node.nextSibling);
      }
    } else {
      normalize(node.firstChild);
    }
    normalize(node.nextSibling);
  };

  const findit = (rootId) => {
    // put the value of the textbox in string
    let string = document.getElementById("fwtext").value;
    const find_msg = document.querySelector("#find_msg");
    const total = document.querySelector("#total");
    const findwindow = document.querySelector("#findwindow");

    // 8-9-2010 Turn DIV to hidden just while searching so doesn't find the text in the window
    findwindow.style.visibility = "hidden";
    //findwindow.style.display = 'none';

    // if the text has not been changed and we have previous finds
    if (
      findText.toLowerCase() ===
        document.getElementById("fwtext").value.toLowerCase() &&
      findPointer >= 0
    ) {
      findnext(highlights); // Find the next occurrence
    } else {
      unhighlight(); // Remove highlights of any previous finds

      if (string === "") {
        // if empty string
        if (find_msg) {
          find_msg.innerHTML = "";
        }
        if (total) {
          total.innerHTML = 0;
        }

        findwindow.style.visibility = "visible";
        return;
      }

      setFindText(string);
      let node;
      // Ver 5.0a - 7/18/2014. Next four lines because root node won't exist until doc loads
      if (rootId !== null) node = document.getElementById(rootId);
      else node = null;

      const arr = [];
      highlight(string, node, arr); // highlight all occurrences of search string

      if (arr.length > 0) {
        // if we found occurences
        setFindPointer(-1);
        findnext(arr); // Find first occurrence
      } else {
        find_msg.innerHTML = " <b>0 " + find_text_inter_span + " 0</b>"; // ver 5.1 - 10/17/2014 - changed from "Not Found"
        setFindPointer(-1);
        total.innerHTML = 0;
      }
    }
    findwindow.style.visibility = "visible";
    //findwindow.style.display = 'block';
  };

  const findnext = (highlights) => {
    let current_find;
    const find_msg = document.querySelector("#find_msg");
    const total = document.querySelector("#total");

    if (findPointer !== -1) {
      // if not first find
      current_find = highlights[findPointer];

      // Turn current find back to yellow
      if (foundHighlightRule === 1) {
        current_find.className = "highlight";
      } else {
        current_find.style.backgroundColor = "yellow";
        current_find.style.color = "black";
      }
    }

    let num = findPointer + 1;
    // 支持循环切换
    if (num === highlights.length) {
      num = 0;
    }
    setFindPointer(num);

    if (num >= highlights.length)
      // if we reached the end
      num = 0; // go back to first find

    let display_find = num + 1;

    find_msg.innerHTML =
      display_find + "" + find_text_inter_span + "" + highlights.length;
    total.innerHTML = highlights.length;

    current_find = highlights[num];

    // Turn selected find orange or add .find_selected css class to it
    if (foundSelectedRule === 1) {
      current_find.className = "find_selected";
    } else {
      current_find.style.backgroundColor = "orange";
      current_find.style.color = "black";
    }

    //highlights[find_pointer].scrollIntoView(); // Scroll to selected element
    scrollToPosition(highlights[findPointer]);
  };

  const findprev = () => {
    const find_msg = document.querySelector("#find_msg");
    const total = document.querySelector("#total");

    let current_find;
    if (highlights.length < 1) {
      return;
    }

    if (findPointer !== -1) {
      // if not first find
      current_find = highlights[findPointer];

      // Turn current find back to yellow
      if (foundHighlightRule === 1) {
        current_find.className = "highlight";
      } else {
        current_find.style.backgroundColor = "yellow";
        current_find.style.color = "black";
      }
    }
    let num = findPointer - 1;
    // 支持循环滚动
    if (num <= -1) {
      num = highlights.length - 1;
    }
    setFindPointer(num);

    if (num < 0)
      // if we reached the beginning
      num = highlights.length - 1; // go back to last find

    let display_find = num + 1;

    find_msg.innerHTML =
      display_find + "" + find_text_inter_span + "" + highlights.length;
    total.innerHTML = highlights.length;

    current_find = highlights[num];

    // Turn selected find orange or add .find_selected css class to it
    if (foundSelectedRule === 1) {
      current_find.className = "find_selected";
    } else {
      current_find.style.backgroundColor = "orange";
      current_find.style.color = "black";
    }

    //highlights[find_pointer].scrollIntoView(); // Scroll to selected element
    scrollToPosition(highlights[num]);
  };

  const isOnScreen = (el) => {
    // Version 5.4d
    /* This checks to see if an element is within the current user viewport or not */

    let screenHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight; // Version 1.2.0
    let screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth; // Version 1.2.0

    /* New way: el.getBoundingClientRect always returns
       left, top, right, bottom of
       an element relative to the current screen viewport */
    let rect = el.getBoundingClientRect();
    if (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= screenHeight &&
      rect.left <= screenWidth
    )
      // Version 1.2.0 - Changed from scrollBottom and scrollRight
      return true;
    else {
      // Verison 1.0.2 - Calculate how many pixels it is offscreen
      let distance = Math.min(
        Math.abs(rect.bottom),
        Math.abs(rect.right),
        Math.abs(rect.top - screenHeight),
        Math.abs(rect.left - screenWidth)
      );

      return -Math.abs(distance); // Version 1.0.2 - Return distance as a negative. Used to return false if off screen
    }
  };

  const scrollToPosition = (field) => {
    // This function scrolls to the DIV called 'edited'
    // It is called with onload.  'edited' only exists if
    // they just edited a comment or the last comment
    // if they just sent a comment

    if (field) {
      if (isOnScreen(field) !== true) {
        // Version 5.4d
        let isSmoothScrollSupported =
          "scrollBehavior" in document.documentElement.style;
        if (isSmoothScrollSupported) {
          field.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          field.scrollIntoView(false);
        }
      }
    }
  };

  const getStyle = (el, styleProp) => {
    // if el is a string of the id or the actual object of the element
    let x = document.getElementById(el) ? document.getElementById(el) : el;
    let y;
    if (x.currentStyle)
      // IE
      y = x.currentStyle[styleProp];
    else if (window.getComputedStyle)
      // FF
      y = document.defaultView
        .getComputedStyle(x, null)
        .getPropertyValue(styleProp);
    return y;
  };

  const textarea2pre = (el) => {
    // el is the textarea element
    let pre;
    // If a pre has already been created for this textarea element then use it
    if (el.nextSibling && el.nextSibling.id && el.nextSibling.id.match(/pre_/i))
      pre = el.nextsibling;
    else pre = document.createElement("pre");

    let the_text = el.value; // All the text in the textarea

    // replace <>" with entities
    the_text = the_text
      .replace(/>/g, ">")
      .replace(/</g, "<")
      .replace(/"/g, '"');
    //var text_node = document.createTextNode(the_text); // create text node for pre with text in it
    //pre.appendChild(text_node); // add text_node to pre
    pre.innerHTML = the_text;

    // Copy the complete HTML style from the textarea to the pre
    let completeStyle = "";
    if (typeof getComputedStyle !== "undefined") {
      // webkit
      completeStyle = window.getComputedStyle(el, null).cssText;
      if (completeStyle !== "")
        // Verison 5.3f - Is empty in IE 10 and Firefox
        pre.style.cssText = completeStyle; // Everything copies fine in Chrome
      else {
        // Version 5.3f - Because cssText is empty in IE 10 and Firefox
        let style = window.getComputedStyle(el, null);
        for (let i = 0; i < style.length; i++) {
          completeStyle +=
            style[i] + ": " + style.getPropertyValue(style[i]) + "; ";
        }
        pre.style.cssText = completeStyle;
      }
    } else if (el.currentStyle) {
      // IE
      let elStyle = el.currentStyle;
      for (let k in elStyle) {
        completeStyle += k + ":" + elStyle[k] + ";";
      }
      //pre.style.cssText = completeStyle;
      pre.style.border = "1px solid black"; // border not copying correctly in IE
    }

    el.parentNode.insertBefore(pre, el.nextSibling); // insert pre after textarea

    // If textarea blur then turn pre back on and textarea off
    el.onblur = function () {
      this.style.display = "none";
      pre.style.display = "block";
    };
    // If textarea changes then put new value back in pre
    el.onchange = function () {
      pre.innerHTML = el.value
        .replace(/>/g, ">")
        .replace(/</g, "<")
        .replace(/"/g, '"');
    };

    el.style.display = "none"; // hide textarea
    pre.id = "pre_" + highlights.length; // Add id to pre

    // Set onclick to turn pre off and turn textarea back on and perform a click on the textarea
    // for a possible onclick="this.select()" for the textarea
    pre.onclick = function () {
      this.style.display = "none";
      el.style.display = "block";
      el.focus();
      el.click();
    };

    // this.parentNode.removeChild(this); // old remove pre in onclick function above
  };

  const selectElementContents = (el) => {
    /* http://stackoverflow.com/questions/8019534/how-can-i-use-javascript-to-select-text-in-a-pre-node-block */
    if (window.getSelection && document.createRange) {
      // IE 9 and non-IE
      let range = document.createRange();
      range.selectNodeContents(el);
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (document.body.createTextRange) {
      // IE < 9
      let textRange = document.body.createTextRange();
      textRange.moveToElementText(el);
      textRange.select();
      //textRange.execCommand("Copy");
    }
  };

  const timerRef = useRef();

  const reset = () => {
    const fwtext = document.querySelector("#fwtext");
    if (fwtext) {
      fwtext.value = "";
    }
    findit("content-area");
    // unhighlight()
  };

  const initFoundRule = () => {
    // Check to see if css rules exist for hightlight and find_selected.
    let sheets = document.styleSheets;
    for (let i = 0; i < sheets.length; i++) {
      // IE <= 8 uses rules; FF & Chrome and IE 9+ users cssRules
      try {
        // Version 5.4c - Fix Firefox "InvalidAccessError: A parameter or an operation is not supported by the underlying object" bug
        let rules = sheets[i]?.rules ? sheets[i].rules : sheets[i].cssRules;
        if (rules !== null)
          for (let j = 0; j < rules.length; j++) {
            if (rules[j].selectorText === `${rules[j].selectorText} .highlight`)
              setFoundHighlightRule(1);
            else if (
              rules[j].selectorText ===
              `${rules[j].selectorText} .find_selected`
            )
              setfoundSelectedRule(1);
          }
      } catch (error) {
        console.error("Caught Firefox CSS loading error: " + error);
      }
    }
  };

  useEffect(() => {
    initFoundRule();
  }, []);

  const preDisabled = highlights.length <= 0 || findPointer <= -1;
  const nextDisabled =
    // (highlights.length > 0 && highlights.length - 1 <= findPointer) ||
    findPointer <= -1 || highlights.length <= 0;

  return (
    <SearchDocWrap id="findwindow">
      <Stack direction={"row"} alignItems={"center"} spacing={2}>
        <TextField
          label={null}
          variant="standard"
          id="fwtext"
          autoComplete="off"
          fullWidth
          onInput={(e) => {
            setFindPointer(-1);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (highlights.length > 0) {
                scrollToPosition(highlights[0]);
              }
            }
          }}
          onChange={(e) => {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
              if (timerRef.current) {
                findit("content-area");
              }
            }, 500);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Box>
                  <Typography
                    id="find_msg"
                    sx={{ color: (theme) => theme.palette.text.disabled }}
                  >
                    0/0
                  </Typography>

                  <Typography
                    sx={{
                      display: "none",
                    }}
                  >
                    共
                    <Typography id="total" component={"span"}>
                      0
                    </Typography>{" "}
                    条
                  </Typography>
                </Box>
              </InputAdornment>
            ),
          }}
          sx={{
            ".MuiInputBase-root": {
              "::before": {
                border: "none !important",
              },
              ":hover": {
                "::before": {
                  border: "none !important",
                },
              },
              "::after": {
                border: "none !important",
              },
            },
            ".Mui-focused": {
              "::after": {
                border: "none !important",
              },
            },
          }}
        />
        <Divider
          orientation="vertical"
          flexItem
          sx={
            {
              // marginTop: "8px !important",
              // marginBottom: "8px !important",
            }
          }
        />

        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          sx={{
            svg: {
              width: 16,
              height: 16,
              flexShrink: 0,
              color: "inherit",
            },
          }}
        >
          {/* pre btn */}
          <IconButton
            sx={{
              width: 32,
              height: 32,
              svg: {
                path: {
                  fill: (theme) =>
                    preDisabled
                      ? theme.palette.text.disabled
                      : theme.palette.text.primary,
                },
              },
            }}
            onClick={() => {
              findprev();
            }}
            disabled={preDisabled}
          >
            <svg
              width="17"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Group 427321018">
                <path
                  id="Vector 34 (Stroke)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.1915 9.19133C15.801 9.58186 15.2733 9.68738 15.013 9.42703L7.4705 1.88456C7.21015 1.62421 7.31568 1.09657 7.7062 0.706049C8.09673 0.315525 8.62436 0.209997 8.88471 0.470346L16.4272 8.01282C16.6875 8.27317 16.582 8.80081 16.1915 9.19133Z"
                  fill="black"
                />
                <path
                  id="Vector 35 (Stroke)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.19133 0.706956C9.58186 1.09748 9.68738 1.62512 9.42703 1.88547L1.88456 9.42794C1.62421 9.68829 1.09657 9.58276 0.706049 9.19224C0.315525 8.80171 0.209997 8.27407 0.470346 8.01373L8.01282 0.471253C8.27317 0.210904 8.80081 0.316431 9.19133 0.706956Z"
                  fill="black"
                />
              </g>
            </svg>
          </IconButton>
          {/* next btn */}
          <IconButton
            sx={{
              width: 32,
              height: 32,
              svg: {
                path: {
                  fill: (theme) =>
                    nextDisabled
                      ? theme.palette.text.disabled
                      : theme.palette.text.primary,
                },
              },
            }}
            onClick={() => {
              findit("content-area");
            }}
            disabled={nextDisabled}
          >
            <svg
              width="17"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Group 427321017">
                <path
                  id="Vector 34 (Stroke)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.706956 0.707107C1.09748 0.316582 1.62512 0.211055 1.88547 0.471405L9.42794 8.01388C9.68829 8.27423 9.58276 8.80186 9.19224 9.19239C8.80171 9.58291 8.27407 9.68844 8.01373 9.42809L0.471253 1.88562C0.210904 1.62527 0.316431 1.09763 0.706956 0.707107Z"
                  fill="black"
                />
                <path
                  id="Vector 35 (Stroke)"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.70711 9.19148C7.31658 8.80096 7.21105 8.27332 7.4714 8.01297L15.0139 0.470498C15.2742 0.210148 15.8019 0.315676 16.1924 0.706201C16.5829 1.09672 16.6884 1.62436 16.4281 1.88471L8.88562 9.42718C8.62527 9.68753 8.09763 9.58201 7.70711 9.19148Z"
                  fill="black"
                />
              </g>
            </svg>
          </IconButton>
          {/* close btn */}
          <IconButton
            sx={{
              width: 32,
              height: 32,
              svg: {
                width: 20,
                height: 20,
                path: {
                  fill: (theme) => theme.palette.text.primary,
                },
              },
            }}
            onClick={() => {
              reset();
              setShowSearch(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.63664 5.63679C6.02717 5.24627 6.66033 5.24627 7.05086 5.63679L18.3646 16.9505C18.7551 17.341 18.7551 17.9742 18.3646 18.3647C17.974 18.7552 17.3409 18.7552 16.9504 18.3647L5.63664 7.05101C5.24612 6.66048 5.24612 6.02732 5.63664 5.63679Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.63679 18.3634C5.24627 17.9728 5.24627 17.3397 5.63679 16.9491L16.9505 5.63543C17.341 5.24491 17.9742 5.24491 18.3647 5.63543C18.7552 6.02596 18.7552 6.65912 18.3647 7.04965L7.05101 18.3634C6.66048 18.7539 6.02732 18.7539 5.63679 18.3634Z"
                fill="black"
              />
            </svg>
          </IconButton>
        </Stack>
      </Stack>
    </SearchDocWrap>
  );
};

export default SearchDoc;

const SearchDocWrap = styled(Box)(({ theme }) => ({
  top: 60,
  right: "40%",
  zIndex: 999,
  position: "fixed",
  width: "480px",
  padding: "16px",
  borderRadius: "16px",
  boxShadow:
    "0px 12px 24px 0px rgba(113, 117, 126, 0.16), 0px 0px 2px 0px rgba(113, 117, 126, 0.16)",
  background: theme.palette.background.default,
  [theme.breakpoints.down("lg")]: {
    right: 0,
  },

  [theme.breakpoints.down("sm")]: {
    right: 16,
    width: "calc(100vw - 32px)",
  },
}));
